import React, {Component} from 'react';

import { t } from 'l10n';

import '../../sass/member/MemberMessageList.scss';

import MessageListItem from './MessageListItem';
import MessageListFilter from './MessageListFilter';

class MessageList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            onApply: false,
            allCheck: false,
            conversationIds: [],
        };
    }

    chooseCheckAll = () => {
        const { messageList } = this.props;
        let {allCheck, conversationIds} = this.state;
        
        conversationIds = !allCheck ? messageList.map((id, i) => (messageList[i].conversation_id)) : [];

        this.setState({
            allCheck: !allCheck,
            conversationIds: conversationIds,
        })
    }

    setChooseListMessage = (id, status) => {
        console.log("id, ", id);
        let { conversationIds } = this.state;

        if(status) {
            conversationIds.push(id);
        } else {
            const index = conversationIds.indexOf(id);
            index > -1 ? conversationIds.splice(index, 1) : null;
        }

        this.setState({
            onApply: false,
            conversationIds: conversationIds,
        });
    }

    onApply() {
        this.setState({
            onApply: true,
            allCheck: false,
            conversationIds: [],
        }); 
    }

    scrollTop() { window.scrollTo(0, 0); }

    messageListItem = () => {
        const {messageList} = this.props;
        const {onApply, allCheck} = this.state;
        console.log(messageList);
        let mList = Object.values(messageList);
        return mList.length ? mList.map((item, key) =>
            <MessageListItem
                chek={allCheck}
                key={key}
                item={item}
                onApply={onApply}
                setChooseListMessage={this.setChooseListMessage}
            />
        ) : <div className="empty-list">{t('No messages')}</div>;
    }

    render() {
        const { showTopButton, trash } = this.props;
        const { allCheck, conversationIds } = this.state;

        return (
            <div className="list-message">
                <div className="content">
                    <MessageListFilter
                        trash={trash}
                        allCheck={allCheck}
                        onApply={this.onApply}
                        conversationIds={conversationIds}
                        chooseCheckAll={this.chooseCheckAll}
                    />
                    <div className="scrollarea">
                        {this.messageListItem()}
                    </div>
                    <div className={`bottom ${showTopButton ? 'show' : ''}`}>
                        <div onClick={this.scrollTop}>
                            <span className="icon" />
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default MessageList;


// WEBPACK FOOTER //
// ./src/components/message/MessageList.js